export default Object.freeze({
    space: 'space',
    dashboard: 'dashboard',
    module: 'module',
    news: 'news',
    more: 'more',
    notifications: 'notifications',
    identity: 'identity',
})
